import React from 'react';
import { checkIsValidInput, isNullOrUndefined } from 'utils/Global';

type RMInputProps = {
  value: any;
  onChange?: (e: any) => void;
  className?: string;
  style?: any;
  allowNegatives?: boolean;
  allowDecimals?: boolean;
  readonly?: boolean;
  name?: string;
  placeHolder?: string;
  onFocus?: (e: any) => void;
  id?: string;
};
export const RMInput = ({
  value,
  onChange,
  className,
  style,
  allowNegatives = false,
  allowDecimals = false,
  readonly = false,
  name = '',
  placeHolder,
  onFocus,
  id,
}: RMInputProps) => {
  function handleOnChange(e) {
    if (allowNegatives && (e.target.value == '-0' || e.target.value == '0-')) {
      // Cover some Exceptional cases here
      e.target.value = allowDecimals ? '-0.1' : '-1';
    } else if (allowDecimals && (e.target.value == '.' || e.target.value == '0.')) {
      e.target.value = '0.';
    } else {
      /// Check and Format the value in numeric format
      if (!checkIsValidInput(e.target.value, allowNegatives)) {
        return;
      } // Don't trigger onChange if not a valid value
      if (e.target.value[0] == '0') {
        if (allowDecimals) {
          e.target.value = isNaN(parseFloat(e.target.value))
            ? 0
            : parseFloat(e.target.value);
        } else {
          e.target.value = isNaN(parseInt(e.target.value)) ? 0 : parseInt(e.target.value);
        }
      } else if (e.target.value == '') {
        e.target.value = 0;
      }
    }

    onChange(e);
  }

  return (
    <input
      id={id ? `rminput-${id}` : 'rminput-default'}
      data-testid={id}
      name={name}
      readOnly={readonly}
      className={className}
      style={style}
      value={isNullOrUndefined(value) ? '' : value}
      onChange={handleOnChange}
      placeholder={placeHolder}
      onFocus={onFocus}
    />
  );
};
